import {
  useGitHelmChartValues,
  GitHelmChartBaseParams,
} from './useGitHelmChartValues';

type GitHelmChartValidationParams = GitHelmChartBaseParams & {
  /** Whether to enable the query */
  enabled?: boolean;
};

/**
 * Hook to validate if a Git path contains a valid Helm chart.
 * Checks for the existence of Chart.yaml in the specified path.
 *
 * This is a convenience wrapper around useGitHelmChartValues with command: 'chart'
 * that returns a simplified validation state.
 *
 * @returns Query result with isValid flag indicating if Chart.yaml exists
 */
export function useGitHelmChartValidation(
  params: GitHelmChartValidationParams
) {
  const chartQuery = useGitHelmChartValues({
    ...params,
    command: 'chart', // Validates Chart.yaml exists
  });

  return {
    ...chartQuery,
    isValid: chartQuery.isSuccess && !!chartQuery.data?.values,
    isChecking: chartQuery.isLoading,
    chartYaml: chartQuery.data?.values,
  };
}
